export default "__VITE_ASSET__B$7II5Vq__"